import { Box, styled } from '@mui/material';
import { HelixPalette } from '../../helix';
/**
 * Styled Box to for the content of the Drawer.
 */
export const DrawerContent = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
}));
/**
 * Styled Box for the header of the Drawer.
 */
export const DrawerHeader = styled(Box)(() => ({
    alignItems: 'center',
    backgroundColor: HelixPalette.neutral05,
    display: 'flex',
    height: '72px',
    justifyContent: 'space-between',
    minHeight: '72px',
    padding: '0.75rem 1.5rem',
}));
/**
 * Styled Box to for the body of the Drawer.
 */
export const DrawerBody = styled(Box)(() => ({
    flex: 1,
    overflowY: 'auto',
}));
/**
 * Styled Box to for the footer of the Drawer.
 */
export const DrawerFooter = styled(Box)(() => ({
    padding: '1rem 1.5rem',
}));
